import { useEffect, useState } from "react";

import { api } from "@/api";
import { Avatar, timeAgo } from "@/components/projects/common";

const TAB = { todo: "todos", message: "discussions", doc: "documents", file: "fichiers", member: "membres", list: "todos" };

export function ActivityFeed({ project, onOpen }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/projects/${project.id}/activity`).then(({ data }) => setItems(data)).catch(() => {}); }, [project.id]);
  const days = items.reduce((acc, a) => {
    const day = new Date(a.created_at).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
    (acc[day] = acc[day] || []).push(a);
    return acc;
  }, {});
  if (!items.length) return <p className="pj-empty">Aucune activité pour l'instant.</p>;
  return (
    <div className="pj-activity" data-testid="activity-feed">
      {Object.entries(days).map(([day, list]) => (
        <section key={day}>
          <h4>{day}</h4>
          <ul>
            {list.map((a) => (
              <li key={a.id} data-testid={`activity-${a.id}`}>
                <Avatar name={a.actor_name} size={28} />
                <p><strong>{a.actor_name}</strong> {a.verb} {TAB[a.target_type] ? <button type="button" className="link-button" onClick={() => onOpen(TAB[a.target_type], a.target_type, a.target_id)}>{a.label}</button> : <em>{a.label}</em>}</p>
                <small>{timeAgo(a.created_at)}</small>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
